import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-beige" data-id="element-86">
      <div className="container mx-auto px-4 max-w-3xl fade-in-section" data-id="element-87">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-card border-2 border-coral/20 text-center relative overflow-hidden" data-id="element-88">
          {/* Decorative background */}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-rose/10 rounded-full blur-3xl pointer-events-none" data-id="element-89"></div>

          <div className="flex justify-center mb-6 relative z-10" data-id="element-90">
            <div className="bg-gradient-to-br from-coral to-coral-dark p-4 rounded-full shadow-lg" data-id="element-91">
              <ShieldCheckIcon className="text-white w-12 h-12" data-id="element-92" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-4 relative z-10" data-id="element-93">
            Garantía de satisfacción de 7 días
          </h2>

          <p className="text-lg text-text-medium mb-6 relative z-10 leading-relaxed" data-id="element-94">
            Estoy tan segura de que este programa va a transformar tu cuerpo,
            que asumo todo el riesgo. Si por cualquier motivo sentís que este
            programa no es para vos, te devolvemos el 100% de tu dinero.
            <strong className="text-text-dark" data-id="element-95">
              {' '}
              Sin preguntas. Sin vueltas.
            </strong>
          </p>

          <div className="w-full h-px bg-gray-200 my-6 relative z-10" data-id="element-96"></div>

          <p className="font-bold text-coral-dark text-xl relative z-10 font-heading italic" data-id="element-97">
            Tu inversión está 100% protegida.
          </p>
        </div>
      </div>
    </section>;
}